import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { ThemeProvider } from './ThemeProvider'
import { TooltipProvider } from '@/components/ui/tooltip'
import { checkAuth } from '@/state/auth/auth.slice'

export default function RootProvider({ children }) {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { isAuthenticated, isLoading } = useSelector((state) => state.auth)

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    })
  }, [])

  // Check auth status on mount (restores session from HttpOnly cookie)
  useEffect(() => {
    dispatch(checkAuth())
  }, [dispatch])

  // Redirect to login if not authenticated (after auth check completes)
  useEffect(() => {
    if (!isLoading && !isAuthenticated && location.pathname !== '/') {
      navigate('/')
    }
  }, [isLoading, isAuthenticated, location.pathname, navigate])

  return (
    <ThemeProvider
      defaultTheme="system"
      storageKey="cetapos-theme"
    >
      <TooltipProvider>{children}</TooltipProvider>
    </ThemeProvider>
  )
}
